import { Collapse } from '@vrplatform/components';
import { LoadingIndicator } from '@vrplatform/components-legacy';
import { Box, Text } from '@mantine/core';

export const DrawerCollapsableSection = ({
  rightSection,
  title,
  loading,
  defaultOpened,
  hideToggle = false,
  children,
}: {
  title: string;
  rightSection?: React.ReactNode;
  loading?: boolean;
  defaultOpened?: boolean;
  hideToggle?: boolean;
  children: React.ReactNode;
}) => {
  return (
    <Box>
      <Collapse
        title={
          <>
            <Text component="span" size="sm" fw={500}>
              {title}
            </Text>
            {loading && <LoadingIndicator size={'0.75rem'} />}
          </>
        }
        rightSection={rightSection}
        minHeight={30}
        defaultOpened={defaultOpened ?? true}
        hideToggle={hideToggle}
      >
        <Box>{children}</Box>
      </Collapse>
    </Box>
  );
};
